<template>
    <div>
        <div class="mainTop cf">
            <navZcy v-bind:num="2"></navZcy>
            <management></management>
        </div>

        <div>
            <div class="aside">
               <div>
                    <el-menu
                            class="el-menu-vertical-demo"
                            @select="handleSelect">
                        <el-submenu index="1">
                            <template slot="title">
                                <i class="el-icon-location"></i>
                                <span>图集管理</span>
                            </template>
                            <el-menu-item index="image">图片素材</el-menu-item>
                            <el-submenu index="atlas">
                                <template slot="title">
                                    <span>图集</span>
                                </template>
                                <el-submenu index="type">
                                    <template slot="title">
                                        <span>海报</span>
                                    </template>
                                    <label v-for="(item,i) in pictureOptions" :key="i">
                                        <el-menu-item :index="`1-` + i.toString()">{{item.name}}</el-menu-item>
                                    </label>
                                </el-submenu>
                                <el-submenu index="spaceId">
                                    <template slot="title">
                                        <span>空间图集</span>
                                    </template>
                                    <label v-for="(item,i) in roomOptions" :key="i">
                                        <el-menu-item :index= "`2-` + i.toString()+ `-` + item.id.toString()">{{item.name}}</el-menu-item>
                                    </label>
                                </el-submenu>
                                <!--<el-submenu index="seriesId">-->
                                    <el-menu-item index="seriesId">系列图集</el-menu-item>
                                    <!--<label v-for="(item,i) in seriesOptions" :key="i">
                                        <el-menu-item :index="`3-` +i.toString() + `-` + item.id.toString()">{{item.name}}</el-menu-item>
                                    </label>-->
                                <!--</el-submenu>-->
                            </el-submenu>
                        </el-submenu>

                    </el-menu>
                </div>
            </div>
        </div>

        <!--<div class="main">
            <div v-if="flag == false">
                <imageZcy></imageZcy>
            </div>
            <div v-else>
                <imgDetailedList :filtrateData="filtrateData" :showTag="showTag" ref="abc"></imgDetailedList>
            </div>
        </div>-->
        <el-col :span="21">
            <div style="margin-left: 10px;margin-top: 10px;">
                <div style="margin-bottom: 10px;">
                    <a>工作台</a>
                </div>

                <el-tabs v-model="editableTabsValue" type="card" closable   @tab-remove="removeTab">
                    <el-tab-pane
                            v-for="(item) in tabData"
                            :key="item.id"
                            :name="item.name"
                            :label="item.label"
                    >
                        <component v-bind:is="item.cmpname"></component>

                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-col>

    </div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    import imageZcy from './image'
    import videoPoster from  './videoPoster'
    import spacePoster from  './spacePoster'
    import seriesPoster from  './seriesPoster'
    import spaceImage from  './spaceImage'
    import seriesImage from  './seriesImage'
    import util from '@/util/util.js'
    import store from '@/util/store.js'
    export default {
        name: "imageManager",
        components:{
            management,
            navZcy,
            imageZcy,
            videoPoster,
            spacePoster,
            seriesPoster,
            spaceImage,
            seriesImage,
        },
        data(){
            return{
                filtrateData:{},
                roomOptions:[],
                seriesOptions:[],
                pictureOptions: [{
                    id: 1,
                    name: '视频海报'
                }, {
                    id: 2,
                    name: '空间海报'
                }, {
                    id: 3,
                    name: '系列海报'
                }],
                editableTabsValue:'',
                tabIndex:0,
                tabData:[],
                componentMap: {
                    imageZcy:{
                        name: '图片素材',
                        single: true,
                    },
                    videoPoster: {
                        name: '视频海报',
                        single: true,
                    },
                    spacePoster: {
                        name: '空间海报',
                        single: true
                    },
                    seriesPoster: {
                        name: '系列海报',
                        single: true
                    },
                    spaceImage:{
                        name: '空间图集',
                        single: true
                    },
                    seriesImage:{
                        name: '系列图集',
                        single: true
                    }
                }
            };
        },
        methods: {
            handleSelect(key, keyPath) {
                if(keyPath[1] === 'atlas'){
                    switch (keyPath[2]) {
                        case 'type':
                            if(key=="1-0"){
                                this.tagEvent('videoPoster')
                            }else if(key=="1-1"){
                                this.tagEvent('spacePoster')
                            }else if(key=="1-2"){
                                this.tagEvent('seriesPoster')
                            }
                            break;
                        case 'spaceId':
                            console.log("key:",key)
                            var str = key.split('-')
                            this.tagEventFB(this.roomOptions[str[1]].name,'spaceImage')
                            store.setAppData('spaceId',parseInt(str[2],10))
                            break;
                        case 'seriesId':
                            /*console.log("key:",key)
                            var str = key.split('-')
                            this.tagEventFB(this.seriesOptions[str[1]].name,'seriesImage')
                            store.setAppData('seriesId',parseInt(str[2],10))*/
                            this.tagEvent('seriesImage')
                            break;
                    }
                }else if(keyPath[1]=='image'){
                    this.tagEvent('imageZcy')
                }
            },
            getRoom() {
                this.$http.post("zcvrVideoApi/imgList/getSpace/" + sessionStorage.getItem('sessionId'), {emulateJson: true}).then(
                    (success) => {
//		  				console.log(success)
                        if (success.body.msg != "ok") {
                            this.roomOptions = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if (success.data.msg == "该SessionId已经超时") {
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/', query: ''})
                            }
                        } else {
                            this.roomOptions = success.body.data;
                        }

                    },
                    (error) => {
                        console.log("数据连接失败")
                    })
            },
            getSeries() {
                this.$http.post("zcvrVideoApi/imgList/getSeries/" + sessionStorage.getItem('sessionId'), {emulateJson: true}).then(
                    (success) => {
//		  				console.log(success)
                        if (success.body.msg != "ok") {
                            this.seriesOptions = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if (success.data.msg == "该SessionId已经超时") {
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/', query: ''})
                            }
                        } else {
                            this.seriesOptions = success.body.data
                        }

                    },
                    (error) => {
                        console.log("数据连接失败")
                    })
            },
            tagEvent(tag){
                var createNew = true
                var existNodeName = ''
                if(this.componentMap[tag].single)
                {
                    for(let i=0;i<this.tabData.length;i++){
                        if(this.tabData[i].cmpname == tag)
                        {
                            existNodeName=this.tabData[i].name
                            createNew = false
                            break
                        }
                    }
                }
                if(createNew) {
                    let newName = tag + this.tabIndex
                    let obj = {
                        name: newName,
                        label: this.componentMap[tag].single?this.componentMap[tag].name:this.componentMap[tag].name + this.tabIndex,
                        cmpname: tag,
                        id:this.tabIndex
                    }
                    console.log(obj)
                    this.tabData.unshift(obj)
                    this.tabIndex = this.tabIndex + 1
                    this.editableTabsValue=newName
                }else{
                    this.editableTabsValue=existNodeName
                }
            },
            tagEventFB(tag,cmpname){

                var createNew = true
                var existNodeName = ''
                console.log("componentMap",this.componentMap[cmpname])
                if(this.componentMap[cmpname].single)
                {
                    console.log("tabData",this.tabData)
                    console.log("tag",tag)
                    for(let i=0;i<this.tabData.length;i++){
                        if(this.tabData[i].label == tag)
                        {
                            existNodeName=this.tabData[i].name
                            createNew = false
                            break
                        }
                    }
                }

                if(createNew) {
                    let newName = tag  + this.tabIndex
                    let obj = {
                        name: newName,
                        label: this.componentMap[cmpname].single?tag:tag + this.tabIndex,
                        cmpname: cmpname,
                        id: this.tabIndex
                    }
                    console.log(obj)
                    this.tabData.unshift(obj)
                    this.tabIndex = this.tabIndex + 1
                    this.editableTabsValue = newName
                }else{
                    this.editableTabsValue=existNodeName
                }
            },
            removeTab(targetName) {
                for(let i=0;i<this.tabData.length;i++){
                    if(this.tabData[i].name == targetName)
                    {
                        this.tabData.splice(i,1)
                        break
                    }
                }
            },
        },
        created() {
            this.getRoom()
            this.getSeries()
        }
    }
</script>

<style scoped>
    .aside{
        width: 11%;
        float: left;
    }
    .main{
        width: 89%;
        float:right;
    }
</style>
